import React, { useEffect, useState, forwardRef } from 'react'
// import { useSelector, useDispatch } from 'react-redux'
// import { useFormContext } from "react-hook-form";
import DatePicker from 'react-datepicker';
import { SvgCalendar } from '../svg';
import moment from 'moment';

const FormDatepicker = ({ fieldName, setValue, register, changeCallback, initial }) => {
  const [startDate, setStartDate] = useState(new Date(initial));

  function customChange(value) {

    const formatted = moment(value).format()
    
    setValue(fieldName, formatted, { shouldTouched: true, shouldDirty: true });
    setStartDate(value);
    //changeCallback(value)
  }

  useEffect(() => {
    const formatted = moment(startDate).format()
    setValue(fieldName, formatted);
  }, [startDate, setValue, fieldName]);

  const CustomInput = React.forwardRef(({ value, onClick, onChange }, ref) => (
    <div className="input-with-icon">
      <input 
        type="hidden" 
        value={moment(startDate).format()}
        {...register(fieldName)}
      />
      <input
        className="form-control"
        ref={ref}
        onClick={onClick}
        value={value}
        readOnly
      />
      <SvgCalendar />
    </div>
  ));

  return (
    <>
      <DatePicker
        dateFormat="dd.MM.yyyy"
        selected={startDate}
        onChange={(date) => customChange(date)}
        customInput={<CustomInput />}
      />
    </>
  );
};

FormDatepicker.defaultProps = {
  initial: new Date()
}

export default FormDatepicker
